import Api from '@/services/Api'

export default {
    getContratoCierreByFecha(fecha){
        return Api().get('contratoCierres/getContratoCierreByFechaCierre/'+fecha)
    },
    createCierreContrato(datos){
        return Api().post('contratoCierres/create',datos)
    },
    getMesesAbiertos(){
        return Api().get('contratoCierres/mesesAbiertos')
    },
    getListadoFechas(){
        return Api().get('contratoCierres/getAllFechas')
    }
}